import { jsx as _jsx } from "react/jsx-runtime";
import Linkify from 'react-linkify';
const linkDecorator = (decoratedHref, decoratedText, key) => (_jsx("a", { target: '_blank', href: decoratedHref, rel: 'noreferrer', children: decoratedText }, key));
const TextWithLinks = ({ children }) => {
    return _jsx(Linkify, { componentDecorator: linkDecorator, children: children });
};
export default TextWithLinks;
